import axios from 'axios';
import { API_ENDPOINT_URL } from '@/config/api_config'

const siteStorage = JSON.parse(localStorage.getItem('site')) || null
const token = siteStorage != null && typeof siteStorage.token !== 'undefined' ? siteStorage.token : (localStorage.getItem('token') || null)

const instance = axios.create({
    baseURL: API_ENDPOINT_URL,
    timeout: 250000,
    headers: {
        'Authorization': 'Bearer ' + token
    }
});

// instance.defaults.headers.get['content-type'] = 'application/x-www-form-urlencoded';
// instance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`

export default instance